/* eslint-disable @typescript-eslint/no-magic-numbers */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { LRUCache } from "lru-cache";
import { inMemoryCacheStats } from "./inMemoryCacheStats";
const cache = new LRUCache({
    ttl: 1000 * 60 * 5, // ttl is in ms, so 5 min
    updateAgeOnGet: true,
    max: 1000 * 1000, // best case: 1M tiny objects of size 100 bytes equals 100 MB
    dispose: (value, _key) => {
        // This is primarily intended to properly dispose ThreeJS Geometries and Materials but should also take care
        // of any other object that features a .dispose() method
        if (value !== null &&
            value !== undefined &&
            typeof value === "object" &&
            "dispose" in value &&
            typeof value.dispose === "function") {
            value.dispose();
        }
    },
});
/**
 * @deprecated Use a strongly typed local instance of LRUCache instead
 */
export const set = (key, value) => {
    cache.set(key, value);
};
/**
 * @deprecated Use a strongly typed local instance of LRUCache instead
 */
export const get = (key) => {
    const result = cache.get(key);
    result ? trackCacheStatsSnapshot(true) : trackCacheStatsSnapshot(false);
    return result;
};
// WARNING: this just exists for unit tests. please try to not use this in the client!
const dumpCache = () => {
    cache.dump();
};
export const forTestingOnly = {
    dumpCache: dumpCache,
};
/**
 * Sums up cache stats and stores them in a global variable for logging.
 *
 * @see SceneStats for original pattern
 * IDEA: put a dev warning in when hit rate too low?
 */
function trackCacheStatsSnapshot(isHit) {
    const cacheHits = inMemoryCacheStats.cacheHits + (isHit ? 1 : 0);
    const cacheMisses = inMemoryCacheStats.cacheMisses + (isHit ? 0 : 1);
    // NOTE: simple math done here for convenience downstream
    const stats = {
        cacheHits,
        cacheMisses,
        cacheHitRate: cacheHits / (cacheHits + cacheMisses),
        // NOTE: For simplicity, use cache size at the last point in time
        cacheSize: cache.size,
    };
    Object.assign(inMemoryCacheStats, stats); // assign to global
}
//# sourceMappingURL=inMemoryCache.js.map